<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter">
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.id"  @keyup.enter.native="getWeChatPushListPageHandle" clearable></el-input>
            </el-form-item>
             <el-form-item label="商品名称：">
                <el-input v-model.trim="searchForm.name"  @keyup.enter.native="getWeChatPushListPageHandle" clearable></el-input>
            </el-form-item>
             <el-form-item label="备注名称：">
                <el-input v-model.trim="searchForm.remark"  @keyup.enter.native="getWeChatPushListPageHandle" clearable></el-input>
            </el-form-item>
             <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.agentName"  @keyup.enter.native="getWeChatPushListPageHandle" clearable></el-input>
            </el-form-item>
              <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
        
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getWeChatPushListPageHandle">搜索</el-button>
                <el-button type="success" @click="pushVisibale = true">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >   
            <el-table-column prop="id" label="订单号" width="160px"></el-table-column>
            <el-table-column prop="smokeName" label="商品名称数量" width="350px"></el-table-column>
            <el-table-column prop="agentName" label="出入库代理"></el-table-column>
              <el-table-column prop="yangan" label="烟杆盒数"></el-table-column>
                <el-table-column prop="yandan" label="烟弹盒数"></el-table-column>
                  <el-table-column prop="yandanCount" label="烟弹总数"></el-table-column>
            <el-table-column prop="typeName" label="类型"></el-table-column>
                   <el-table-column label="备注"  width="500px">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.remark"  @change="updateSortNo(scope.row)" clearable></el-input>
                </template>
               </el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
              <el-table-column label="操作"  width="180px" >
                <template slot-scope="scope">
                    <el-button  type="text" @click="getOptFailListHandler(scope.row.id, $event)">流水记录</el-button>
                    <el-button style="text" plain @click="exportExcel('/mould/downloadSmoke?id='+scope.row.id)">导出清单</el-button>
                </template>
            </el-table-column>
        </el-table>       
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
 
        <el-dialog :append-to-body="true"  title="列表" :visible.sync="optFailVisible" width="1000px" :close-on-click-modal="false">
            <!-- <el-button type="primary" @click="confirmExportDialogVisible = true" style="margin-bottom:10px;"> 导 出</el-button> -->
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="typeName" label="操作类型"></el-table-column>
                <el-table-column prop="count" label="盒数"></el-table-column>
                <el-table-column prop="yandanCount" label="盒/个数"></el-table-column>
                <el-table-column prop="smokeName" label="商品名称"></el-table-column>
                 <el-table-column label="备注"  width="500px">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.remark"  @change="updateSortNo1(scope.row)" clearable></el-input>
                </template>
               </el-table-column>
                <el-table-column prop="createTime" label="时间"></el-table-column>
            </el-table>  
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>
        <el-dialog :append-to-body="true"  title="出入库" :visible.sync="pushVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchDataForm" :model="searchDataForm" label-width="85px">
                <el-form :model="searchDataForm" :inline="true" class="forTbFilter">
             <el-form-item label="商品名称：">
                <el-input v-model.trim="searchDataForm.name"  @keyup.enter.native="getDataInfos" clearable></el-input>
            </el-form-item> 
             <el-form-item label="产品种类：">
                <el-select v-model="searchDataForm.type" clearable>
                    <el-option value="5" label="烟杆"></el-option>
                    <el-option value="6" label="烟弹"></el-option>
                    <el-option value="12" label="手提袋"></el-option>
                    <el-option value="13" label="展盒"></el-option>
                    <el-option value="14" label="抽台"></el-option>
                </el-select>
          </el-form-item>
           <el-form-item label="产品分组："> 
                <el-select v-model="searchDataForm.typeGroupId" clearable>
                    <el-option v-for="item in cardStateOption" :value="item.id" :key="item.id + item.name" :label="item.name"></el-option>
                </el-select>
            </el-form-item>       
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getDataInfos">搜索</el-button>
            </el-form-item>
        </el-form>
                <el-form-item label="选择产品：" prop="region">
                    <el-table
                        :data="suppliers.tableData"
                        tooltip-effect="dark"
                        border height="300"
                        @selection-change="handleCheckedSuppliersChange">
                        <el-table-column type="index" label="序号"> </el-table-column>
                        <el-table-column type="selection" > </el-table-column>
                        <el-table-column label="产品名称" >
                            <template slot-scope="scope">{{ scope.row.name }}</template>
                        </el-table-column>
                         <el-table-column type="index" label="盒数"  width="160px"> 
                              <el-input slot-scope="scope" v-model="scope.row.count" clearable></el-input>
                         </el-table-column>
                           <el-table-column type="index" label="盒/个数"  width="160px"> 
                              <el-input slot-scope="scope" v-model="scope.row.size" clearable></el-input>
                         </el-table-column>
                    </el-table>
                </el-form-item>
                 <el-form-item label="已选产品：" prop="region">
                    <el-table
                        :data="suppliers1.tableData"
                        tooltip-effect="dark"
                        border height="300"
                        @selection-change="handleCheckedSuppliersChange1">
                        <el-table-column type="index" label="序号"> </el-table-column>
                        <el-table-column type="selection" > </el-table-column>
                        <el-table-column label="产品名称" >
                            <template slot-scope="scope">{{ scope.row.name }}</template>
                        </el-table-column>
                         <el-table-column type="index" label="盒数"  width="160px"> 
                              <el-input slot-scope="scope" v-model="scope.row.count" clearable></el-input>
                         </el-table-column>
                           <el-table-column type="index" label="盒/个数"  width="160px"> 
                              <el-input slot-scope="scope" v-model="scope.row.size" clearable></el-input>
                         </el-table-column>
                    </el-table>
                </el-form-item>
                 <el-form-item label="代理商：" prop="agentName">
                    <el-input v-model="pushForm.agentName"  show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="pushForm.remark" type="textarea" rows="3" maxlength="10" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="进入库：" prop="type">
                    <el-radio-group v-model="pushForm.type">
                        <el-radio :label="3">入库</el-radio>
                        <el-radio :label="4">出库</el-radio>
                    </el-radio-group>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="weChatPushHandle">确 定</el-button>
            </div>   
        </el-dialog>
     
    </div>
</template>
<script>
import {getWeChatPushList, doWeChatPush, getWeChatPushSupplierList,smokeOutListInfo,smokeOutUpdate,smokeOutList} from '@/api/system.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
             pushForm: {
                checkedSuppliers: [],
                title: '',
                agentId: '',
                colourState: 4,
                remark: '',
                type: 3,
            },
            searchForm: {
                remark: '',
                name:'',
                agentName:'',
                time:'',
                id:'',
                smokeType:''
            },
             searchDataForm: {
                type: '',
                name:'',
                typeGroupId:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            agentListOption: [],
            suppliers: {
                tableData:[]
            },   
            suppliers1: {
                tableData:[]
            },      
            pushVisibale: false,

           
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },
             supplierOption: [
                 {
                    code:5,
                    description:'烟杆'
                },
                 {
                    code:6,
                    description:'烟弹'
                },
                 {
                    code:12,
                    description:'手提袋'
                },
                 {
                    code:13,
                    description:'展盒'
                },
                 {
                    code:14,
                    description:'抽台'
                }
            ],
            timesOption:[
            {
                    code:9,
                    description:'畅刻二代系列'
                },
                 {
                    code:10,
                    description:'悦刻五代系列'
                },
                 {
                    code:11,
                    description:'畅刻五代系列'
                }
                   
            ],

            pushRules: {
                title: [{required: true, message: '请输入公告标题', trigger: 'blur'}],
                content: [{required: true, message: '请输入公告内容', trigger: 'blur'}]
            },
            optFailVisible:false,
            currentId_fail:'',
             cardStateOption:[],
        }
    },
    methods: {
        getDataInfos(){
            common.sysRequest('smoke/type/info/list', this.searchDataForm, 'post').then(res => {
            if(res.data.code == 200){
                this.suppliers.tableData = res.data.data;
            }   
        });
        },
          getOptFailListHandler(id, $event){
            this.optFailVisible = true;
            this.currentId_fail = id;
            var searchData = {id}
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchData);
            smokeOutListInfo(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        cancel(){
            this.pushVisibale = false;
        },
        getWeChatPushListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            smokeOutList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            });

          
        },        
          updateSortNo(row){
            //备注修改
            var data = {
                id: row.id,
                remark: row.remark
            }
            common.sysRequest('smoke/smoke/in/out/remark', data, 'post').then(res => {
            if(res.data.code == 200){
                 this.$message.success(res.data.message);
               this.getWeChatPushListPageHandle();
            }else{
                 this.$message.error(res.data.message);
            }   
        })
        },
                  updateSortNo1(row){
            //备注修改
            var data = {
                id: row.id,
                remark: row.remark
            }
            common.sysRequest('smoke/smoke/in/out/remark/log', data, 'post').then(res => {
            if(res.data.code == 200){
                 this.$message.success(res.data.message);
               this.getWeChatPushListPageHandle();
            }else{
                 this.$message.error(res.data.message);
            }   
        })
        },
        weChatPushHandle(){
            if(this.pushForm.checkedSuppliers.length < 1){
                this.$message.error('请先选择供应商');
                return;
            }

                    let data = this.pushForm;
                    let supplierIdsArr = []; let supplierNamesArr = []; let supplierCountsArr = [];let supplierSize = [];

                    for(let i=0; i<this.pushForm.checkedSuppliers.length; i++){
                        supplierIdsArr[i] = this.pushForm.checkedSuppliers[i].id;
                        supplierNamesArr[i] = this.pushForm.checkedSuppliers[i].name;
                        supplierCountsArr[i] = this.pushForm.checkedSuppliers[i].count;
                        supplierSize[i] = this.pushForm.checkedSuppliers[i].size;
                    }
                    data.smokeIds = supplierIdsArr.join("_");
                    data.smokeCounts = supplierCountsArr.join("_");
                    data.smokeSizes = supplierSize.join("_");

                    smokeOutUpdate(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.pushVisibale = false;
                            this.pushForm = {
                                checkedSuppliers: [],
                                title: '',
                                content: '',
                                colourState: 4,
                                templateId: '',
                                urls: '',
                            };
                            this.suppliers1.tableData=[];
                            this.getWeChatPushListPageHandle();
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
        },
        handleCheckedSuppliersChange1(val){
            this.pushForm.checkedSuppliers=val;
        },
        handleCheckedSuppliersChange(val){

            for(let item of val) {
                //查询有没有重复元素
                for(let info of this.suppliers1.tableData){
                    if(info.name==item.name){
                        this.suppliers1.tableData.splice(this.suppliers1.tableData.indexOf(info),1);
                    }
                }
                 this.suppliers1.tableData.push(item);
           }
            console.log( this.suppliers1.tableData)
        },


        handleSizeChange(val){
           
        },
         handleSizeChange(val){
            if(this.optFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getOptFailListHandler(this.currentId_fail);
            }else{
                 this.tbpg.pageSize = val;
                this.getWeChatPushListPageHandle();
            }
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getWeChatPushListPageHandle();
        }  
    },
    created () {
         common.getAgentListOptionCom(this, 'agentListOption');
        this.getWeChatPushListPageHandle();
         common.sysRequest('smoke/type/info/list', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.suppliers.tableData = res.data.data;
            }   
        });
         common.sysRequest('smoke/type/list', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.cardStateOption = res.data.data;
            }   
        })
    } 
}
</script>
<style lang="less">
.WeChatPushDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }
    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

